type ENV_CONFIG = {
    localDev: boolean;
    apiBaseUrl?: string;
}

export const CONFIG: ENV_CONFIG = {
    localDev: window.location.hostname === "localhost",
    apiBaseUrl: window.location.hostname === "localhost" ? "http://localhost:8787/" : "https://engagement.isabella-nathaniel.com/"
}